import { Button } from "@progress/kendo-react-buttons";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { PageTabItemTitle } from "components/tabs/TabItem/PageTabItemTitle";
import React from "react";
import { useState } from "react";
import CompanyAccounting from "./CompanyAccounting";
import CompanyProfile from "./CompanyDetails";
import styles from "../Settings.module.scss";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import { updateCompany, useCompany } from "services/companyService";
import SubmitButton from "components/common/SubmitButton";

const Company = () => {
  const [tabs, setTabs] = useState(["Company Details", "Financial Settings"]);
  const [selected, setSelected] = React.useState(0);
  const navigate = useNavigate();
  const [serviceAddress, setServiceAddress] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);

  const { data: subdata } = useCompany();

  const updateAddress = (data) => {
    if (data.workingDays !== undefined && data.workingDays !== null) {
      const selWd = [];
      data?.workingDays?.map((day) => {
        if (day?.isChecked) {
          selWd.push(day?.label);
        }
      });
      data.workingDays = selWd?.toString(",");
    }
    setServiceAddress({ ...serviceAddress, ...data });
    setHasChanges(true);
  };

  const handleSelect = (e) => {
    setSelected(e.selected);
  };

  const submitHandler = async () => {
    if (!hasChanges) return;

    setIsSubmitting(true);
    try {
      const res = await updateCompany(subdata.id, serviceAddress);
      if(res.success) {
        toast.success("Company Updated Successfully");
      }
      setHasChanges(false);
    } catch (error) {
      toast.error("Failed to update company");
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <div className={`${styles[`company`]}`}>
      <TabStrip
        keepTabsMounted={true}
        selected={selected}
        onSelect={handleSelect}
        className="mt-3 pagetab"
      >
        {tabs.map((item, index) => {
          return (
            <TabStripTab
              key={index}
              title={
                <PageTabItemTitle
                  title={item}
                  index={tabs.indexOf(item)}
                  selected={selected}
                />
              }
            >
              <div className={`${styles[`company-tabs`]}`}>
                {item === "Company Details" && (
                  <CompanyProfile updateAddress={updateAddress} />
                )}
                {item === "Financial Settings" && (
                  <CompanyAccounting updateAddress={updateAddress} />
                )}
              </div>
            </TabStripTab>
          );
        })}
      </TabStrip>
      <div
        className={`${styles["buttons-container"]} d-flex align-items-center justify-content-between col-12 p-3 mt-2`}
        style={{ width: "90%" }}
      >
        <div></div>
        <div className="d-flex align-items-center gap-2 me-2">
          <Button
            className={`common-btn bgBtnSecondary me-3`}
            type="button"
            onClick={() => {
              navigate(`/settings`);
            }}
          >
            Cancel
          </Button>
          <SubmitButton
            className="me-3"
            onClick={submitHandler}
            isLoading={isSubmitting}
            disabled={!hasChanges}
          >
            Update
          </SubmitButton>
        </div>
      </div>
    </div>
  );
};

export default Company;
